import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Route, Switch, useLocation } from 'react-router-dom'
import { AddRounded } from '@mui/icons-material'

import { useStores } from '@trivie/core'
import { NavigationTabs } from '@trivie/ui-web/components/navigation-tabs'
import { Header } from '@trivie/ui-web/components/header'

import { SubscriptionCreateDialog } from './create-subscription/subscription-create'
import { SubscriptionProductDetailScreen } from './subscriptions-product-detail-screen'
import { SubscriptionPurchaseDetailScreen } from './subscriptions-purchase-detail-screen'
import { SubscriptionProductsTab } from './tabs/subscriptions-products-tab'
import { SubscriptionPurchasesTab } from './tabs/subscriptions-purchases-tab'

export const SubscriptionsScreen: React.FunctionComponent = observer(() => {
  const [showCreateDialog, setShowCreateDialog] = useState(false)
  const [editingProduct, setEditingProduct] = useState<any>(null)
  const location = useLocation()

  const isSubscriptionsTab = location.pathname === '/activities/subscriptions'

  const { manageUserStore } = useStores()
  const { permissions } = manageUserStore

  const handleCreateProduct = () => {
    setEditingProduct(null)
    setShowCreateDialog(true)
  }

  const handleEditProduct = (product: any) => {
    setEditingProduct(product)
    setShowCreateDialog(true)
  }

  const handleCloseDialog = () => {
    setShowCreateDialog(false)
    setEditingProduct(null)
  }

  const primary = {
    disabled: !permissions?.permissions.some((p) => p.code === 'can_create_product'),
    startIcon: <AddRounded />,
    onClick: handleCreateProduct,
    text: 'Create Subscription',
  }

  return (
    <Switch>
      <Route exact path="/activities/subscriptions/purchases/:id/:tab?">
        <SubscriptionPurchaseDetailScreen />
      </Route>
      <Route exact path="/activities/subscriptions/:id(\d+)/:tab">
        <SubscriptionProductDetailScreen />
      </Route>
      <Route exact path={['/activities/subscriptions', '/activities/subscriptions/purchases']}>
        <Header title="Subscriptions" primaryAction={isSubscriptionsTab ? primary : undefined} />
        <NavigationTabs
          tabList={[SubscriptionProductsTab(handleEditProduct), SubscriptionPurchasesTab]}
        />
        {showCreateDialog && (
          <SubscriptionCreateDialog
            open={showCreateDialog}
            requestClose={handleCloseDialog}
            editingProduct={editingProduct}
          />
        )}
      </Route>
    </Switch>
  )
})
